import { TextBlock } from '../other/text-block.js'
import { LinkBlock } from '../other/link-block.js'
import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ListBlock } from './list-block.js'
import { BlockStyle } from '../styles/block-style.js'
import { Expression } from '../../data/text-or-code.js'
import { TextOrExpression_assumeText } from '../../data/text-or-code.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

@jsonClass('MainLayoutSidebarBlock')
export class MainLayoutSidebarBlock extends Block {
	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Hide completely',
		tooltip: () => ({
			text: 'Hide this sidebar completely for all screen sizes; this should be used if you don\t want to have a side bar at all under certain circumstances (e.g. an anonymous user).',
		}),
		codeLanguage: 'ts',
		editorSize: 'singleline',
		isBinding: false,
		tsReturnType: () => 'boolean',
		alternativeContentAreaName: 'header',
	})
	hideCompletelyCode = new Expression('false')

	@jsonProperty(TextOrExpression_assumeText)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Session storage key',
		tooltip: () => ({
			text: 'The key to use for storing and loading the state of the sidebar in session storage. Leave empty to not store the state in session storage.',
		}),
		codeLanguage: 'ts',
		editorSize: 'singleline',
		isBinding: false,
		tsReturnType: () => 'boolean',
		alternativeContentAreaName: 'header',
	})
	sessionStorageKeyCode = new TextOrExpression_assumeText('sidebar_isOpen')

	constructor(init: Partial<MainLayoutSidebarBlock> = {}) {
		super()
		this.init(init)
	}

	static createNewForEditor(): Block {
		return new this({
			styles: [new BlockStyle({ name: 'width', value: '15em' })],
			children: [
				new ListBlock({
					kind: 'navigation',
					children: [
						new LinkBlock({
							children: [
								new TextBlock({
									text: 'Link',
								}),
							],
						}),
					],
				}),
			],
		})
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#78909c'
	}

	getTitleColor(): string {
		return 'white'
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}

	getSidenavVariableName() {
		return 'sidebar_' + this.id
	}
}
